import logo from '../../../assets/images/logo/logo.png';

function HeaderLogo({ showAsideBar }) {
  return (
    <div className="nav-header d-flex align-items-center justify-content-between px-3">
      {/* Left: Hamburger icon */}
      <div className="nav-control" onClick={showAsideBar}>
        <div className="hamburger">
          <span className="line" />
          <span className="line" />
          <span className="line" />
        </div>
      </div>

      {/* Center: Logo */}
        <div className="d-flex justify-content-center w-100">
        <a href="/admin" className="brand-logo d-flex align-items-center justify-content-center">
          <img
            src={logo}
            alt="Logo"
            className="img-fluid"
          />
        </a>
      </div>

      {/* Right: Empty div to balance spacing */}
      <div style={{ width: '40px' }}></div>
    </div>
  );
}

export default HeaderLogo;
